import { useCallback, useState } from 'react';
import styled from 'styled-components';
import { KOALA } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import CallFromNumberOptions from './CallFromNumberOptions';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import { DISTANCE_MEASUREMENT_EXTRA_SMALL } from 'HubStyleTokens/sizes';
import { WEB_FONT_MEDIUM_WEIGHT } from 'HubStyleTokens/misc';
import { useCallFromNumberContext } from '../contexts/CallFromNumberContext';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "CallFromNumberAccordionItem__Wrapper",
  componentId: "sc-10k69xq-0"
})(["padding:", ";border-style:solid;border-width:2px 0 0 0;border-color:", ";"], DISTANCE_MEASUREMENT_EXTRA_SMALL, KOALA);
const StyledUIAccordionItem = styled(UIAccordionItem).withConfig({
  displayName: "CallFromNumberAccordionItem__StyledUIAccordionItem",
  componentId: "sc-10k69xq-1"
})(["margin-top:", ";"], DISTANCE_MEASUREMENT_EXTRA_SMALL);
const BodyWrapper = styled.div.withConfig({
  displayName: "CallFromNumberAccordionItem__BodyWrapper",
  componentId: "sc-10k69xq-2"
})(["margin-left:-18px;"]);
const StyledFormattedMessage = styled(FormattedMessage).withConfig({
  displayName: "CallFromNumberAccordionItem__StyledFormattedMessage",
  componentId: "sc-10k69xq-3"
})(["font-weight:", ";"], WEB_FONT_MEDIUM_WEIGHT);
const CallFromNumberAccordionItem = () => {
  const [open, setOpen] = useState(false);
  const {
    selectedFromNumber,
    setSelectedFromNumber
  } = useCallFromNumberContext();
  const handleSelectFromNumber = useCallback(fromNumber => {
    setSelectedFromNumber(fromNumber);
  }, [setSelectedFromNumber]);
  const displayFromNumber = !selectedFromNumber ? '' : selectedFromNumber.get('nickname') && selectedFromNumber.get('nickname').length ? `${selectedFromNumber.get('nickname')} ${selectedFromNumber.get('friendlyName')}` : selectedFromNumber.get('friendlyName');
  return /*#__PURE__*/_jsx(Wrapper, {
    children: /*#__PURE__*/_jsx(StyledUIAccordionItem, {
      open: open,
      onOpenChange: () => setOpen(!open),
      title: /*#__PURE__*/_jsx(StyledFormattedMessage, {
        message: "call-highlight-card.returnCall.callFrom",
        options: {
          number: displayFromNumber
        }
      }),
      children: /*#__PURE__*/_jsx(BodyWrapper, {
        children: /*#__PURE__*/_jsx(CallFromNumberOptions, {
          onSelect: handleSelectFromNumber
        })
      })
    })
  });
};
export default CallFromNumberAccordionItem;